import Swiper from 'swiper';
import * as localForage from 'localforage';
import * as memoryDriver from 'localforage-driver-memory';
import type { Product } from '@gate31/types/product';

localForage.defineDriver(memoryDriver);
localForage.setDriver([ localForage.LOCALSTORAGE, memoryDriver._driver ]);

const DATA_UI_FAVORITES_TRIGGER = 'data-ui-favorites-trigger';
const DATA_BTN_TEXT = 'data-btn-text';
 
export default class Favorite {
    private static FavoritesProducts = window.FavoritesProducts;

    constructor() {}

    static getItems(): Promise<Product[]> {
        return new Promise((resolve, reject) => {
            window.ajaxAPI.favorites.get().done((data: { products: Product[] }) => resolve(data.products)).fail(reject);
        });
    }

    static getIdList(): Promise<Array<number>> {
        return Favorite.getItems().then(products => products.map(product => product.id));
    }

    // Получаем состояние - меняем состояние
    static add(id: number) {
        Favorite.FavoritesProducts.add({ item: id });

        return Favorite?.getIdList();
    }

    // Получаем состояние - меняем состояние
    static remove(id: number) {
        Favorite.FavoritesProducts.remove({ item: id });

        return Favorite?.getIdList();
    }

    static init() {
        document.querySelectorAll(`[${DATA_UI_FAVORITES_TRIGGER}]`).forEach(button => {
            button.querySelector(`[${DATA_BTN_TEXT}]`)?.setAttribute('data-ui-favorites-trigger-added-text', 'Убрать из избранного');
            button.querySelector(`[${DATA_BTN_TEXT}]`)?.setAttribute('data-ui-favorites-trigger-not-added-text', 'Добавить в избранное');
        });
    }

    static initSlider() {
        const wrapper = document.querySelector<HTMLDivElement>('.page-favorite__recommendation');

        if (! wrapper) {
            return;
        }

        wrapper.style.display = 'block';

        return new Swiper('.page-favorite__recommendation .index-slider', {
            loop: true,
            slidesPerView: 2,
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination'
            }
        });
    }
}

// Глобальная видимость для any-query поиска
window.Favorite = {
    add: Favorite.add,
    remove: Favorite.remove,
    getIdList: Favorite.getIdList
};
